(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  const heroWrapper = document.querySelector('.hero-wrapper');

  function initHeroVideo() {
    const video = document.getElementById('hero-video-1');
    const contentWrapper = document.querySelector('.hero__content-wrapper');

    if (video && contentWrapper && heroWrapper) {
      contentWrapper.classList.remove('hero-video-btn-visible');
      heroWrapper.classList.add('hero-video-playing-body');
      video.currentTime = 0;
      video.play();
    }
  }

  const video = document.getElementById('hero-video-1');
  if (video) {
    video.addEventListener('ended', function() {
      const contentWrapper = document.querySelector('.hero__content-wrapper');
      if (contentWrapper) contentWrapper.classList.add('hero-video-btn-visible');
      if (heroWrapper) heroWrapper.classList.remove('hero-video-playing-body');
    });
  }

  initHeroVideo();

  window.addEventListener('pageshow', function(e) {
    if (e.persisted) initHeroVideo();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
